const yesNoTradingLossKnowledge = {
    yes: 'Oui',
    no: 'Non',
    dunno: 'Je ne sais pas',
};
export default yesNoTradingLossKnowledge;
